export default __webpack_public_path__ + "static/media/flag-papua-new-guinea.5133dd65.svg";